module.exports = __webpack_public_path__ + "static/face-blue-1883c53d6c5f20676e2e31b850da8470.png";